/* eslint-disable */

import * as React from 'react';

/**
 * Defines the decorator.
 * This decorator is supposed to be applied on properties (without accessor defined.) of the view model.
 * The property applied with this decorator will be added with an extra behavior when setting the property value for the purpose of notifying the UI framework that a new value is set to this property.
 * But the way how this extra behavior notifies the UI framework doesn't matter here since we don't want to introduce any UI framework dependency here and in the view model.
 * The actual view component based on the UI framework (e.g. React) will call the specific binding setup function to implement the way for notifying view model property changes.
 * Please refer to setupUIBindingForReactFunctionalComponent in UIBindingForReact.ts for React version of binding setup.
 * Usage:
 * class SampleViewModel {
 *   @BindUI() public sampleProperty: string;
 * }
 */
export function BindUI() {
    return function decorate(target: any, property: string) {
        const viewModelForUIBinding = target as ViewModelForUIBinding;
        if (!viewModelForUIBinding.__uiUpdateNotificationMap) {
            viewModelForUIBinding.__uiUpdateNotificationMap = {};
        }
        viewModelForUIBinding.__uiUpdateNotificationMap[property] = null;

        let propertyValue = target[property];
        const getter = () => {
            return propertyValue;
        };
        const setter = (newValue: any) => {
            propertyValue = newValue;
            const extraSetter = viewModelForUIBinding.__uiUpdateNotificationMap[property];
            if (extraSetter) {
                extraSetter(newValue);
            }
        };

        Object.defineProperty(target, property, {
            get: getter,
            set: setter,
            enumerable: true,
            configurable: true,
        });
    };
}

/**
 * Defines the view model for UI binding.
 * The key part here is the key value pair which stores each of the decorated property and its UI update notification function.
 */
export type ViewModelForUIBinding = {
    __uiUpdateNotificationMap: { [property: string]: (value: any) => void };
}

export function SetupUIBindingForReactFunctionalComponent(viewModel: any) {
    for (const property in viewModel) {
        if(viewModel.skipUIBindingProperties && viewModel.skipUIBindingProperties.indexOf(property)!==-1){
            continue;
        }

        (function (p) {
            let propertyValue = viewModel[p];

            const [state, setState] = React.useState(viewModel[p]);

            const getter = () => {
                return propertyValue;
            };
            const setter = (newValue: any) => {
                propertyValue = newValue;
                console.log('UIBinding '+p+': '+newValue);
                setState(newValue);
            };

            Object.defineProperty(viewModel, p, {
                get: getter,
                set: setter,
                enumerable: true,
                configurable: true,
            });
        })(property);
    }
}